// extracted by mini-css-extract-plugin
module.exports = {"footer":"Table_footer__2h-L_"};